import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** Simple forbidden page for role-gated routes. */
export default function ForbiddenPage() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="h4" fontWeight={700} color="text.primary" mb={1}>
        403
      </Typography>
      <Typography color="text.secondary" mb={3} maxWidth={420}>
        {t("errors.forbidden", {
          defaultValue: "У вас немає доступу до цієї сторінки.",
        })}
      </Typography>
      <Button variant="contained" onClick={() => navigate("/")}>
        {t("errors.goHome", { defaultValue: "На головну" })}
      </Button>
    </Box>
  );
}
